import { getCompressedAssetUrl } from 'lib/config/assetUrls';

// Gifting imagery on S3 under web_v2/gifting/ (same layout as the upload folder).
const ROOT = 'web_v2/gifting';

/** `src` for CustomImage (no leading slash: a leading slash means a local /public file). */
export const giftingAsset = (path: string): string => `${ROOT}/${path}`;

/** Absolute speedsize URL for CSS `url()` / masks; speedsize sends CORS `*`, which masks need. */
export const giftingAssetUrl = (path: string): string =>
  getCompressedAssetUrl(`/${ROOT}/${path}`);
